import { _ } from "~/i18n";
import { node } from "~/util/dom";
import { createFilterButton } from "~/ui/filterbutton";

interface IReviewMotivationOptions {
	count: number;
	label: string;
	className: string;
	onChange: (event: Event) => void;
	rejected: number;
	onlyRejected: boolean;
}

export default class ReviewMotivation {
	_text: HTMLSpanElement;

	_container: HTMLDivElement;

	_counter: HTMLSpanElement;

	_wrapper: HTMLDivElement;

	_filterButton: HTMLLabelElement;

	_options: IReviewMotivationOptions;

	constructor({
		count = 0,
		label = "mymap.reviews.motivation",
		className = "",
		onChange = undefined,
		rejected = 0,
		onlyRejected = false,
	}: Partial<IReviewMotivationOptions>) {
		this._options = {
			count,
			label,
			className,
			onChange,
			rejected,
			onlyRejected,
		};
		this._text = node("span", { className: `ui-reviewmotivation__text`, innerHTML: _(this._options.label, { count: this._options.count }) }) as HTMLSpanElement;
		this._container = node("p", { className: `ui-reviewmotivation ${this._options.className}` }) as HTMLDivElement;
		this._counter = node("span", { className: `ui-reviewmotivation__counter`, innerHTML: `<strong>${this._options.count.toString()}</strong> ` }) as HTMLSpanElement;
		this._wrapper = node("div", { className: "ui-reviewmotivation__wrapper" });

		this._wrapper.appendChild(this._text);
		this._container.appendChild(this._counter);
		this._container.appendChild(this._wrapper);

		this.rejected = this._options.rejected;
	}

	/* eslint-disable class-methods-use-this */
	destroy() {
		/**/
	}

	set count(count: number) {
		this._text.innerHTML = _(this._options.label, { count });
		this._counter.innerHTML = `<strong>${count.toString()}</strong> `;
		this._options.count = count;
	}

	get count() {
		return this._options.count;
	}

	set rejected(rejected: number) {
		if (this._filterButton) {
			this._filterButton.removeEventListener("change", this._options.onChange);
			this._filterButton.remove();
			this._filterButton = undefined;
			this._container.classList.remove("ui-reviewmotivation--with-filter");
		}

		if (rejected > 0) {
			this._filterButton = createFilterButton({
				checked: this._options.onlyRejected,
				label: node("span", { innerHTML: `<em class="ui-reviewmotivation__filerbutton__exclamation">!</em> ${_("mymap.reviews.rejected", { rejected })}` }),
				value: "filter",
				type: "filter",
			});

			this._options.onChange && this._filterButton.addEventListener("change", this._options.onChange);
			this._wrapper.appendChild(this._filterButton);
			this._container.classList.add("ui-reviewmotivation--with-filter");
		}

		this._options.rejected = rejected;
	}

	get rejected() {
		return this._options.rejected;
	}

	get node() {
		return this._container;
	}
}
